import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from '~/store/store-context';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useSaveCustomPageText = ()=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isLoading } = useMutationState({
        mutationFn: async (param)=>{
            let { businessId, textId, sourceId, content } = param;
            const serialized = JSON.stringify(content);
            const result = textId === '' ? await api.customPage.createText(businessId, sourceId, serialized) : await api.customPage.updateText(businessId, textId, sourceId, serialized);
            queryClient.setQueryData([
                QueryKeys.CustomPageText,
                sourceId,
                result.textId
            ], content);
            return result;
        }
    });
    return {
        saveText: mutateAsync,
        isLoading
    };
};
